import FaqImage from './FaqImage'

import ReEngagementDesktopPng from './assets/ReEngagementDesktop.png'
import ReEngagementMobilePng from './assets/ReEngagementMobile.png'
import ReEngagementDesktopWebp from './assets/ReEngagementDesktop.webp'
import ReEngagementMobileWebp from './assets/ReEngagementMobile.webp'

import RepeatPurchaseCampaignsDesktopPng from './assets/RepeatPurchaseCampaignsDesktop.png'
import RepeatPurchaseCampaignsMobilePng from './assets/RepeatPurchaseCampaignsMobile.png'
import RepeatPurchaseCampaignsDesktopWebp from './assets/RepeatPurchaseCampaignsDesktop.webp'
import RepeatPurchaseCampaignsMobileWebp from './assets/RepeatPurchaseCampaignsMobile.webp'

import TrialToPaidConversionDesktopPng from './assets/TrialToPaidConversionDesktop.png'
import TrialToPaidConversionMobilePng from './assets/TrialToPaidConversionMobile.png'
import TrialToPaidConversionDesktopWebp from './assets/TrialToPaidConversionDesktop.webp'
import TrialToPaidConversionMobileWebp from './assets/TrialToPaidConversionMobile.webp'

import CartAbandonmentDesktopPng from './assets/CartAbandonmentDesktop.png'
import CartAbandonmentMobilePng from './assets/CartAbandonmentMobile.png'
import CartAbandonmentDesktopWebp from './assets/CartAbandonmentDesktop.webp'
import CartAbandonmentMobileWebp from './assets/CartAbandonmentMobile.webp'

import LowRecencyPurchaseWinbackDesktopPng from './assets/LowRecencyPurchaseWinbackDesktop.png'
import LowRecencyPurchaseWinbackMobilePng from './assets/LowRecencyPurchaseWinbackMobile.png'
import LowRecencyPurchaseWinbackDesktopWebp from './assets/LowRecencyPurchaseWinbackDesktop.webp'
import LowRecencyPurchaseWinbackMobileWebp from './assets/LowRecencyPurchaseWinbackMobile.webp'

import OnboardingDesktopPng from './assets/OnboardingDesktop.png'
import OnboardingMobilePng from './assets/OnboardingMobile.png'
import OnboardingDesktopWebp from './assets/OnboardingDesktop.webp'
import OnboardingMobileWebp from './assets/OnboardingMobile.webp'

import PaidSubscriptionAcquisitionDesktopPng from './assets/PaidSubscriptionAcquisitionDesktop.png'
import PaidSubscriptionAcquisitionMobilePng from './assets/PaidSubscriptionAcquisitionMobile.png'
import PaidSubscriptionAcquisitionDesktopWebp from './assets/PaidSubscriptionAcquisitionDesktop.webp'
import PaidSubscriptionAcquisitionMobileWebp from './assets/PaidSubscriptionAcquisitionMobile.webp'

const data = [
  {
    title: `Cart Abandonment`,
    description: `Win back users to drive purchases while optimizing ad spend and discounting.`,
    image: (
      <FaqImage
        alt="Cart Abandonment"
        desktop={CartAbandonmentDesktopPng}
        mobile={CartAbandonmentMobilePng}
        desktopWebp={CartAbandonmentDesktopWebp}
        mobileWebp={CartAbandonmentMobileWebp}
        height={670}
      />
    ),
  },
  {
    title: `Repeat Purchase Campaigns`,
    description: `Convert one-time buyers by delivering communications in their preferred channels.`,
    image: (
      <FaqImage
        alt="Repeat Purchase Campaigns"
        desktop={RepeatPurchaseCampaignsDesktopPng}
        mobile={RepeatPurchaseCampaignsMobilePng}
        desktopWebp={RepeatPurchaseCampaignsDesktopWebp}
        mobileWebp={RepeatPurchaseCampaignsMobileWebp}
        height={600}
      />
    ),
  },
  {
    title: `Low Recency Purchase Winback`,
    description: `Drive returning purchases with personalized discounts based on intent signals.`,
    image: (
      <FaqImage
        alt="Low Recency Purchase Winback"
        desktop={LowRecencyPurchaseWinbackDesktopPng}
        mobile={LowRecencyPurchaseWinbackMobilePng}
        desktopWebp={LowRecencyPurchaseWinbackDesktopWebp}
        mobileWebp={LowRecencyPurchaseWinbackMobileWebp}
        height={666}
      />
    ),
  },
  {
    title: `Trial to Paid Conversion`,
    description: `Engage the right messaging at the right time in all the right channels.`,
    image: (
      <FaqImage
        alt="Trial to Paid Conversion"
        desktop={TrialToPaidConversionDesktopPng}
        mobile={TrialToPaidConversionMobilePng}
        desktopWebp={TrialToPaidConversionDesktopWebp}
        mobileWebp={TrialToPaidConversionMobileWebp}
        height={522}
      />
    ),
  },
  {
    title: `Onboarding`,
    description: `Guide users through onboarding based on real-time behavior.`,
    image: (
      <FaqImage
        alt="Onboarding"
        desktop={OnboardingDesktopPng}
        mobile={OnboardingMobilePng}
        desktopWebp={OnboardingDesktopWebp}
        mobileWebp={OnboardingMobileWebp}
        height={522}
      />
    ),
  },
  {
    title: `Re-engagement`,
    description: `Design personalized messaging based on user preferences and behavior.`,
    image: (
      <FaqImage
        alt="Re-engagement"
        desktop={ReEngagementDesktopPng}
        mobile={ReEngagementMobilePng}
        desktopWebp={ReEngagementDesktopWebp}
        mobileWebp={ReEngagementMobileWebp}
        height={683}
      />
    ),
  },
  {
    title: `Paid Subscription Acquisition`,
    description: `Engage at the right time with personalized messaging to drive conversions.`,
    image: (
      <FaqImage
        alt="Paid Subscription Acquisition"
        desktop={PaidSubscriptionAcquisitionDesktopPng}
        mobile={PaidSubscriptionAcquisitionMobilePng}
        desktopWebp={PaidSubscriptionAcquisitionDesktopWebp}
        mobileWebp={PaidSubscriptionAcquisitionMobileWebp}
        height={670}
      />
    ),
  },
]

export { data }
